import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redirect';
import { A, EllipsedLabel } from 'ui-components/src';
import isRdp from 'ui-pam/src/features/MySessions/common/sessionsUtils';
import CountdownTimer from 'ui-pam/src/features/MySessions/views/PrivilegedSessions/components/CountdownTimer/CountdownTimer';
import './CardView.scss';
import { useSelector } from 'react-redux';


const CardView = ({
  data,
  LaunchSession,
  extraProps,
  requestHistoryCount,
  onRequestHistory,
  intl,
  showEnterDetailsPopup,
}) => {
  const { isJitaEnabledAccount } = useSelector((state) => state.user);

  return (
    <div className="d-flex flex-wrap card_view_sessions">
      {data.map(row => {
        const future = !(row.taskStatus === 2);
        return (
          <div className="card-view mb-3" key={row.privilegeId}>
            <div className="card d-inline-flex">
              <div className="card-header pl-0 pr-0 pt-2 ml-0 d-flex justify-content-between">
                {row.checkbox}
              </div>
              <div className="card-body d-flex flex-column">
                <div className="cardBody-header">
                  {' '}
                  <EllipsedLabel maxLength="18" label={row.instanceId} />{' '}
                </div>
                <div className="cardBody-subHeader">
                  <EllipsedLabel maxLength="10" label={row.privilegeId} /> <span className="dot" />{' '}
                  <span className="bodySub-text">
                    {(row.authenticationType && row.authenticationType.toLowerCase() === 'snc') ||
                    row.credentialtype
                      ? row.credentialtype.toLowerCase() === 'credentialless'
                        ? 'Credential-less'
                        : row.credentialtype
                      : 'Role'}
                  </span>
                  <div className="bodySub-text">
                    {row.remoteAppMetadata && row.remoteAppMetadata.displayName}
                  </div>
                </div>
                {row.requestId === '530151' && extraProps ? (
                  <div className="suspicious-activity">
                    <img src="/ECMv6/assets/images/flag-icon.png" className="flag-icon" alt="flag-icon" />
                    <span className="suspicious-text">Suspicious Activity</span>
                  </div>
                ) : null}
                {/* {row.requestId === '530151' && extraProps ? (
                  <div className="suspicious-activity">(Suspicious Activity Detected)</div>
                ) : null} */}
              </div>
              <div className="card-footer d-flex flex-column">
                <div className="footer-requestId">
                  Request{' '}
                  <A
                    className="requestLink"
                    onClick={() => {
                      push(`/request/requestHistory/${row.requestId}`);
                    }}
                  >
                    #<span>{row.requestId}</span>
                  </A>
                </div>
                <div className="footer-text">
                  <span className={future ? 'label-left' : 'text-content'}>
                    {future ? (<>
                      <CountdownTimer
                          targetDate={new Date(row.enddate).getTime()}
                          leftText={''}
                          item={row}
                          hideTimer={true}
                        />
                        {intl.formatMessage({ id: 'PrivilegedSessions.List.notActive' })}
                        </>
                    ) : (
                      <>
                        <CountdownTimer
                          targetDate={new Date(row.enddate).getTime()}
                          leftText={intl.formatMessage({ id: 'PrivilegedSessions.List.left' })}
                          item={row}
                        />{' '}
                      </>
                    )}
                  </span>
                  {/* <span className="body-text">{showLeftDurationForSession(row.enddate)}</span> */}
                </div>
                {(
                  <button
                    type="button"
                    className={future ? 'btn  btn-access mt-1 future-disabled' : 'btn btn-primary'}
                    onClick={() => {
                      if (
                        row.connectionType.toLowerCase() === 'ad' &&
                        isRdp(row.remoteAppMetadata)
                      ) {
                        showEnterDetailsPopup(row, future);
                        return;
                      }
                      if (!future) LaunchSession(row);
                    }}
                  >
                    {!!row.remoteAppMetadata &&
                      !isRdp(row.remoteAppMetadata) &&
                      (row.remoteAppMetadata.icon.toLowerCase() === 'mysql_workbench' ? (
                        <img src="/ECMv6/assets/images/mysql_workbench.png" className="app-icon" />
                      ) : row.remoteAppMetadata.icon.toLowerCase() === 'toad' ? (
                        <img src="/ECMv6/assets/images/toad.png" className="app-icon" />
                      ) : (
                        <img src="/ECMv6/assets/images/globe.png" className="app-icon" />
                      ))}
                    {future
                      ? intl.formatMessage({ id: 'PrivilegedSessions.List.launch' })
                      : row.remoteAppMetadata === undefined || isRdp(row.remoteAppMetadata)
                      ? intl.formatMessage({ id: 'PrivilegedSessions.List.access' })
                      : intl.formatMessage({ id: 'PrivilegedSessions.List.launchViaApp' })}
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      })}
      {requestHistoryCount > 0 && (
        <div className="card_view_sessions privileged_card_Sessions">
          <div className="card d-inline-flex">
            <div className="card-body">
              <a className="" rel="noopener noreferrer" target="_blank" href>
                <i className="icon-size">
                  <img src="/ECMv6/assets/images/time.png" alt="connector logo" className="connector" />
                </i>
              </a>
              <div className="pending_sessions_count">
                You have{' '}
                {requestHistoryCount === 1
                  ? `${requestHistoryCount} session`
                  : `${requestHistoryCount} sessions`}{' '}
                pending approval, go to{' '}
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-ingrid btn-outline-primary request_history_button mt-1"
                  type="submit"
                  onClick={onRequestHistory}
                >
                  {intl.formatMessage({ id: 'activeSessions.RequestHistory' })}
                </button>
              </div>
              <div className="latestStatus">Or you can start</div>
              <span
                className="new-request"
                role="button"
                tabIndex={0}
                onClick={() => push(isJitaEnabledAccount ? '/request/jitAccess' : '/request/privilegedAccess')}
                onKeyDown={() => {}}
              >
                {intl.formatMessage({ id: 'activeSessions.NewRequest' })}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

CardView.propTypes = {
  LaunchSession: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      privilegeId: PropTypes.number.isRequired,
    })
  ).isRequired,
  extraProps: PropTypes.arrayOf.isRequired,
  showEnterDetailsPopup: PropTypes.func.isRequired,
};

export default CardView;
